import { Media } from '../constant';

type ResizeCallback = (type: Media) => void

// 绑定 resize 事件
export const bindResize = (callback: ResizeCallback, run = true, name?: string) => {
  let timer: any = null;
  const eventName = name ? `resize.${name}` : 'resize';
  const handleScale = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      const type = (window.innerWidth >= document.documentElement.clientHeight)
        ? Media.Landscape
        : Media.Portrait;
      typeof callback === 'function' && callback(type);
    }, 116);
  };
  window.addEventListener(eventName, handleScale);
  run && handleScale();
};

// 是否滚动到可视区域
export const scrollToView = ($el: HTMLElement) => {
  const bodyHeight = document.body.clientHeight;
  const curTop = $el.getBoundingClientRect().top;
  return curTop <= bodyHeight;
};
